const MIN_QUESTIONS = 2;
const MAX_QUESTIONS = 6;
const MIN_QUESTION_LENGTH = 10;
const MAX_QUESTION_LENGTH = 160;

const FENCE_PATTERN = /```(?:json)?\s*([\s\S]*?)```/;
const ARRAY_PATTERN = /\[[\s\S]*\]/;
const LIST_ITEM_PATTERN = /^\s*(?:\d+[.)]|[-*])\s+(.+)$/;
const QUOTED_PATTERN = /["“]([^"”]+)["”]/;
const EDGE_QUOTES_PATTERN = /^["'“”]+|["'“”]+$/g;

const stripFence = (text: string): string =>
  text.match(FENCE_PATTERN)?.[1] ?? text;

const withinBounds = (questions: string[]): string[] | null => {
  const kept = [
    ...new Set(
      questions.filter(
        (question) =>
          question.length >= MIN_QUESTION_LENGTH &&
          question.length <= MAX_QUESTION_LENGTH,
      ),
    ),
  ];
  return kept.length >= MIN_QUESTIONS && kept.length <= MAX_QUESTIONS
    ? kept
    : null;
};

const fromJsonArray = (text: string): string[] | null => {
  const source = text.match(ARRAY_PATTERN)?.[0];
  if (source === undefined) return null;
  try {
    const parsed: unknown = JSON.parse(source);
    if (!Array.isArray(parsed)) return null;
    return withinBounds(
      parsed
        .filter((item): item is string => typeof item === "string")
        .map((item) => item.trim()),
    );
  } catch {
    return null;
  }
};

const fromListLines = (text: string): string[] | null =>
  withinBounds(
    text
      .split("\n")
      .flatMap((line) => {
        const item = line.match(LIST_ITEM_PATTERN)?.[1];
        if (item === undefined) return [];
        const undecorated = item.replaceAll("**", "");
        const quoted = undecorated.match(QUOTED_PATTERN)?.[1] ?? undecorated;
        return [quoted.replace(EDGE_QUOTES_PATTERN, "").trim()];
      })
      .filter((question) => question.length > 0),
  );

export const parseSuggestedQuestions = (text: string): string[] | null => {
  const unfenced = stripFence(text);
  return fromJsonArray(unfenced) ?? fromListLines(unfenced);
};
